import { memo } from "react";

const AssetTableWrapComponent = ({ children }: { children: React.ReactNode }) => {
    return (
        <div className="rounded-[8px] overflow-hidden relative bg-[var(--vote-table-wrap-bg)] border-[var(--vote-table-wrap-border)] border-[1px] flex flex-col gap-0">
            {children}
        </div>
    );
};

export const AssetTableWrap = memo(AssetTableWrapComponent);

AssetTableWrap.displayName = "AssetTableWrap";
